<template>
  <div
    :data-fav-id="`${id}`"
    :class="{ active: showFavMenu, dfav: checkFav }"
    class="fav-btn"
    title="Закладки"
  >
    <!-- <i @click.stop="toggleFav($event)" /> -->
    <i v-if="!checkFav" @click.stop="showFavMenu = !showFavMenu" />
    <i v-else @click.stop="toggleFav()" />

    <transition name="fade">
      <ul v-if="showFavMenu" class="fav-list">
        <li
          @click="toggleFav($event, 'planned')"
          :class="{ active: checkFav && checkFav[0].action === 'planned' }"
        >Запланировано</li>
        <li
          @click="toggleFav($event, 'watching')"
          :class="{ active: checkFav && checkFav[0].action === 'watching' }"
        >Смотрю <span>/ Читаю</span></li>
        <li
          @click="toggleFav($event, 'completed')"
          :class="{ active: checkFav && checkFav[0].action === 'completed' }"
        >Просмотрено <span>/ Прочитано</span></li>
        <li
          @click="toggleFav($event, 'hold')"
          :class="{ active: checkFav && checkFav[0].action === 'hold' }"
        >Отложено</li>
        <li
          @click="toggleFav($event, 'dropped')"
          :class="{ active: checkFav && checkFav[0].action === 'dropped' }"
        >Брошено</li>
        <li
          @click="toggleFav($event, 'rewatching')"
          :class="{ active: checkFav && checkFav[0].action === 'rewatching' }"
        >Пересматриваю</li>
      </ul>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: { fav: { type: Object, require: true, default: () => ({}) } },
  computed: {
    ...mapState(['user']),
    id() {
      let id
      if (this.fav.wa_id) {
        id = this.fav.wa_id
      } else if (this.fav.kinopoisk_id) {
        id = this.fav.kinopoisk_id
      } else if (this.fav.sh_id) {
        id = this.fav.sh_id
      } else {
        id = this.fav.id
      }
      return '' + id
    },
    checkFav() {
      if (!this.user || !this.user.favs) return
      const result = this.user.favs.filter(el => {
        if (el.id === this.id) {
          return el
        }
      })
      return result.length ? result : null
    }
  },
  data() {
    return {
      showFavMenu: false
    }
  },
  methods: {
    async toggleFav(event = false, type = 'planned') {
      if (this.user) {
        // const elem = event
        //   ? event.target.parentElement.classList.contains('dfav')
        //   : false
        // const user = this.user

        // const elem = document.querySelector(`div[data-fav-id="${this.id}"]`)

        // const dFav = elem ? elem.classList.contains('dfav') : null

        if (!this.checkFav) {
          const obj = {
            user_id: this.user.id,
            date: Date.now(),
            type: this.fav.type,
            action: type || 'planned',
            episode: '0',
            season: '0',
            id: this.id,
            title_ru: this.fav.title_ru
              ? this.fav.title_ru
              : this.fav.title
                ? this.fav.title
                : '',
            poster: this.filmPoster(this.fav)
          }
          await this.$axios.post(`/api/user/favs`, obj)
          this.showFavMenu = false
          this.$store.commit('setError', { status: 'ok', msg: 'Закладка добавлена' })
          this.user.favs.push(obj)
          setTimeout(() => this.$store.commit('clearError'), 1100)
        } else {
          await this.$axios.delete(`/api/user/favs?type=${this.fav.type}&id=${this.id}`)
          this.showFavMenu = false
          const elemPos = this.user.favs.findIndex(el => el.id === this.id)
          console.log('this.user.favs', this.user.favs)
          this.user.favs.splice(elemPos, 1)
          console.log('this.user.favs', this.user.favs)
          this.$store.commit('setError', { status: 'warn', msg: 'Закладка удалена' })
          setTimeout(() => this.$store.commit('clearError'), 1100)
        }
      } else {
        this.$store.commit('setShowAuthForm', true)
        this.$store.commit('setError', 'Необходимо войти на сайт')
        setTimeout(() => this.$store.commit('clearError'), 2000)
      }
    }
  }
}
</script>

<style lang="stylus">
.fav-btn
  display inline-block
  position absolute
  left 5px
  top 5px
  z-index 3
  .fav-list
    list-style none
    position absolute
    padding 45px 0 5px
    top 0
    left 0
    width 205px
    color #000
    background-color #fff
    border-radius 5px
    text-align left
    box-shadow 0 0 10px 0 rgba(0 0 0 0.1)
    z-index 1
    li
      padding 9px 15px
      color #000 !important
      font-size 1.4rem
      font-weight normal
      background-color #fff !important
      cursor pointer
      &:hover
        background-color #f1f1f1 !important
      &.active
        font-weight bold
      span
        font-size 1.2rem
        color #aaa
  i
    display block
    position relative
    width 40px
    height 40px
    padding 12px
    background rgba(0 0 0 0.5) url('/static_files/icons/star-plus.svg') center no-repeat
    background-size 26px
    border-radius 5px
    transition all .2s ease
    cursor pointer
    z-index 2
    &:hover
      background #8bc34a url('/static_files/icons/star-plus.svg') center no-repeat
      background-size 26px
  &.dfav i
    background red url('/static_files/icons/star-minus.svg') center no-repeat
    background-size 26px
    &:hover
      background red url('/static_files/icons/star-minus.svg') center no-repeat
      background-size 26px
  &.active i
    background #8bc34a url('/static_files/icons/cancel-dark.svg') center no-repeat
    background-size 16px
</style>
